import { VEHICLE_CHARGING_SESSION } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  vehicleChargingSession: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const vehicleChargingSessionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case VEHICLE_CHARGING_SESSION.REQUEST: {
      return { ...state, isLoading: true };
    }
    case VEHICLE_CHARGING_SESSION.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        vehicleChargingSession: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case VEHICLE_CHARGING_SESSION.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default vehicleChargingSessionReducer;
